import React from 'react';
import classnames from 'classnames/bind';
import { isEmpty } from 'lodash';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { PAGE_VIEW_EVENT_NAME, SHOPIFY_PIXEL_SOURCE_TYPE } from 'modules/PixelTester/config/pixelTesterConsts';
import { COMMON_FLAGS, useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import { EventCardHeader } from './components/EventCardHeader/EventCardHeader';
import { EventData } from './components/EventData/EventData';
import { UnrecognisedEventDescription } from './components/UnrecognisedEventDescription/UnrecognisedEventDescription';
import styles from './event.module.scss';

const classNameBuilder = classnames.bind(styles);

export const Event = ({ eventData, highlightedKeys }) => {
    const { [COMMON_FLAGS.PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS]: defaultShopifyEvents } = useCommonConfig([
        COMMON_FLAGS.PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS,
    ]);

    if (!eventData) {
        return null;
    }
    const { id, eventName, matchedRules = [], pixelIntegrationType } = eventData;
    const eventType = matchedRules?.[0]?.type ?? CONVERSION_TYPE.EVENT_BASED;
    const conversionName = matchedRules?.[0]?.conversionName;
    const hasConversions = !isEmpty(matchedRules);
    const isDefaultShopifyEvent =
        pixelIntegrationType === SHOPIFY_PIXEL_SOURCE_TYPE && defaultShopifyEvents.includes(eventName);
    const isDefaultPageViewEvent = eventName === PAGE_VIEW_EVENT_NAME && !hasConversions;
    const isAutomaticallyFired = isDefaultShopifyEvent || isDefaultPageViewEvent;
    const showDescription = !hasConversions && !isAutomaticallyFired;
    const isHighlighted = highlightedKeys?.has?.(eventData._key) ?? false;

    return (
        <CommonCollapsibleCard
            bodyClassName={styles['card-body']}
            headerClassName={classNameBuilder('card-header', { highlighted: isHighlighted })}
            containerClassName={styles['card-container']}
            descriptionClassName={styles['description']}
            id={`PIXEL_TESTER_EVENT_${conversionName}_${id}`}
            isInitiallyCollapsed
            header={
                <EventCardHeader
                    conversionName={conversionName}
                    eventType={eventType}
                    eventData={eventData}
                    hasConversions={hasConversions}
                    isAutomaticallyFired={isAutomaticallyFired}
                />
            }
            description={showDescription ? <UnrecognisedEventDescription eventData={eventData} /> : null}
        >
            <EventData eventData={eventData} eventType={eventType} />
        </CommonCollapsibleCard>
    );
};
